// Creeper is the analytics pixel the join pages (atm-static's stan.js) and bar
// already report to; its events land in BigQuery creeper2.events. These
// helpers build the same request stan.event() does, so tour events sit next
// to prejoin.view / prejoin.submit and join on the stan_session cookie.
export const CREEPER_PIXEL_URL = "https://d3rxdtgl24x4wt.cloudfront.net/e.gif"

// Where a tour event happened: tour or tour_sfw, with _box for visitors shown
// the embedded join box. The join box sends bar the same value as its
// join_source. The variant rides in location because creeper drops requests
// carrying a field it doesn't know.
export const tourLocation = ({ ageRestricted, variant }) =>
  [ageRestricted ? "tour_sfw" : "tour", variant === "box" && "box"]
    .filter(Boolean)
    .join("_")

export const browserLanguage = (nav) =>
  (nav.languages?.[0] || nav.language || "en").slice(0, 2)

// The domain stan cookies live on: the last two labels of the host.
export const rootDomain = (hostname) => hostname.split(".").slice(-2).join(".")

// Matches stan.device.deviceType().
export const deviceType = (userAgent) => {
  const ua = userAgent.toLowerCase()
  if (
    /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
      ua,
    )
  ) {
    return "tablet"
  }
  if (
    /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(
      ua,
    )
  ) {
    return "smartphone"
  }
  if (/(bot|spider|bubing|slurp)/.test(ua)) return "bot"
  return "desktop"
}

// A stan_session id in the format bar mints (StanServices.random_id): seconds
// since the start of the UTC year, right-padded to 10 digits, then 8 hex.
export const newSessionId = (now = new Date(), randomHex = randomHex8) => {
  const yearStart = Date.UTC(now.getUTCFullYear(), 0, 1)
  const seconds = Math.floor((now.getTime() - yearStart) / 1000)
  return String(seconds).padEnd(10, "0") + randomHex()
}

const randomHex8 = () =>
  Array.from(crypto.getRandomValues(new Uint8Array(4)), (byte) =>
    byte.toString(16).padStart(2, "0"),
  ).join("")

// Encoded the way stan.creeper.sendPayload() does. Blank fields are left out
// rather than sent as "undefined".
export const creeperPixelUrl = (payload) => {
  const query = Object.entries(payload)
    .filter(
      ([, value]) => value !== undefined && value !== null && value !== "",
    )
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&")
  return `${CREEPER_PIXEL_URL}?${query}`
}
